import { jQuery } from '../../../../vendor/jquery';
import { Vue } from '../../../Utility/Vue';
import _ from 'underscore';
import { moment } from '../../../../vendor/moment';

declare global {
    interface Window {
        // global vendors
        $: typeof jQuery;
        jQuery: typeof jQuery;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Vue: any;
        _: typeof _;
        moment: typeof moment;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        kWidget: any;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        mw: any;
    }
}

window.$ = jQuery;
window.jQuery = jQuery;
window.Vue = Vue;
window._ = _;
window.moment = moment;
